export class State {
    stateName: any;
}